import { Avatar, Box } from "@mui/material";
import { StyledBadge } from "core/board/components/board.card";
import { Candidate } from "core/board/interface";
import { useMemo } from "react";

type Props = {
  user: Candidate;
}

const UserAvatar: React.FC<Props> = ({ user }) => {
  const avatarSubstitute = useMemo(() => {
    return user.full_name[0].toUpperCase();
  }, [user.full_name]);

  return (
    <Box>
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        variant="dot"
        invisible={!user.available}
      >
        <Avatar
          alt={user.full_name}
          src={user.avatar_url}
          sx={{ width: 32, height: 32, backgroundColor: "divider" }}
        >
          {!user.avatar_url && avatarSubstitute}
        </Avatar>
      </StyledBadge>
    </Box>
  );
};

export default UserAvatar;

